import { render, staticRenderFns } from "./supplierWarehouseModal.vue?vue&type=template&id=add3a4ae&scoped=true"
import script from "./supplierWarehouseModal.vue?vue&type=script&lang=js"
export * from "./supplierWarehouseModal.vue?vue&type=script&lang=js"
import style0 from "./supplierWarehouseModal.vue?vue&type=style&index=0&id=add3a4ae&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "add3a4ae",
  null
  
)

export default component.exports